import {Component, ChangeDetectionStrategy} from '@angular/core';
import {VisitContext} from '../visit-context';

@Component({
    selector: 'app-ribbon',
    templateUrl: './history-ribbon.component.html',
    styleUrls: ['./history-ribbon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HistoryRibbonComponent {
  visitContext = VisitContext;
}
